import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/core";
import { filter, map, get, size } from "lodash";

import Grid from "@material-ui/core/Grid";

import SchedulerException from "../SchedulerException/SchedulerException";
import SchedulerOccurrenceDaily from "../SchedulerOccurrence/SchedulerOccurrenceDaily";
import SchedulerCalendarTimeSlot from "../SchedulerCalendarTimeSlot/SchedulerCalendarTimeSlot";
import SchedulerOccurrenceDraggable from "../SchedulerOccurrence/SchedulerOccurrenceDraggable";

import {
  getDayVisitorsCount,
  getExceptions,
  getOverlapExceptionsCount,
  getTimeSlotHeight,
  isOccurrenceInTimeSlot,
} from "../../../utils/scheduler";

import { calendarViews } from "../../../constants/common";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";

const styles = {
  container: {
    height: "100%",
    "@media print": {
      //maxWidth: "calc(100% - 1.5cm)",
    },
  },
  headerItem: {
    height: "40px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    padding: "0px 9px",
    backgroundColor: colors.calendarLightBlue,
    borderRight: `3px solid ${colors.white}`,
    borderBottom: `3px solid ${colors.white}`,
    "& span": {
      color: colors.black87,
    },
    "& img": {
      marginRight: "7px",
      height: "14px",
    },
  },
  timeSlotSeparator: {
    height: "26px",
    marginBottom: "2px",
    backgroundColor: colors.veryLighPink,
  },
};

const columnsWidth = [165, 133, 300, null, 105];

const SchedulerCalendarDaily = (props) => {
  const { classes, timeSlots, refresh, showCustomTimeSlots } = props;

  const data = get(props, ["data", 0, "occurrences"]);

  const exceptions = getExceptions(data, timeSlots);

  const timeSlotHeights = map(timeSlots, (slot) =>
    getTimeSlotHeight(props.data, slot, calendarViews.daily)
  );

  const exceptionsColumnWidth =
    Math.max(size(exceptions) > 0 && showCustomTimeSlots
      ? 60 * getOverlapExceptionsCount(exceptions)
      : get(columnsWidth, [4]), 105);
  return (
    <Grid
      container
      data-test="scheduler-calendar-daily-component"
      className={classes.container}
    >
      <Grid item xs>
        <Grid container direction="column">
          <Grid item container>
            <Grid
              item
              className={classes.headerItem}
              style={{ width: get(columnsWidth, [0]) }}
            >
              <img src={images.host_icon_black} alt="clock" />
              <span>{`${I18n.get("scheduler_appointements")}`}</span>
            </Grid>
            <Grid
              item
              className={classes.headerItem}
              style={{ width: get(columnsWidth, [1]) }}
            >
              <img src={images.locationIcon} alt="location" />
              <span>{I18n.get("profiles_location2")}</span>
            </Grid>
            <Grid
              item
              className={classes.headerItem}
              style={{ width: get(columnsWidth, [2]) }}
            >
              <img src={images.pedestrianIcon} alt="visitors" />
              <span>{`${I18n.get("scheduler_visitors2")} (${getDayVisitorsCount(
                data
              )})`}</span>
            </Grid>
            <Grid
              item
              xs
              className={classes.headerItem}
              style={{
                borderRight:
                  !showCustomTimeSlots || size(exceptions) === 0 ? "none" : "",
              }}
            >
              <img src={images.noteIcon} alt="notes" />
              <span>{I18n.get("profiles_comments")}</span>
            </Grid>
          </Grid>
          {map(timeSlots, (slot, index) => (
            <React.Fragment key={index}>
              <SchedulerCalendarTimeSlot
                date={get(props, ["data", 0, "start"])}
                slot={slot}
                timeSlots={timeSlots}
                height={get(timeSlotHeights, [index])}
                refresh={refresh}
              >
                {map(
                  filter(data, (item) => isOccurrenceInTimeSlot(item, slot)),
                  (item, i) => (
                    <SchedulerOccurrenceDraggable
                      key={i}
                      group={item}
                      refresh={refresh}
                    >
                      <SchedulerOccurrenceDaily
                        key={index * 100 + i}
                        group={item}
                        columnsWidth={columnsWidth}
                        timeSlots={timeSlots}
                        refresh={refresh}
                        data-test="scheduler-occurrence-item"
                      />
                    </SchedulerOccurrenceDraggable>
                  )
                )}
              </SchedulerCalendarTimeSlot>
              <Grid item className={classes.timeSlotSeparator} />
            </React.Fragment>
          ))}
        </Grid>
      </Grid>
      {showCustomTimeSlots && size(exceptions) > 0 && (
        <Grid item style={{ position: "relative" }}>
          <Grid container direction="column">
            <Grid
              item
              className={classes.headerItem}
              style={{ width: exceptionsColumnWidth, borderRight: "none", background: "none", border: "0.5px solid black" }}
            >
              <span style={{position:"relative"}}>{I18n.get("dashboard_custom")}</span>
            </Grid>
            <Grid item>
              {map(exceptions, (e, index) => (
                <SchedulerException
                  key={index}
                  group={e}
                  refresh={refresh}
                  timeSlots={timeSlots}
                  timeSlotHeights={timeSlotHeights}
                  offsetTop={40}
                  calendarView={calendarViews.daily}
                  index={index}
                  exceptions={exceptions}
                  type={"day"}
                />
              ))}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default withStyles(styles)(SchedulerCalendarDaily);
